export const roundTo = (
  numberToRound: number,
  numberOfSigns: number = 3,
  mode: 'default' | 'lower' | 'upper' = 'default'
): number => {
  //for numberOfSigns === 3, the following returns "000"
  const zeroes = [...Array(numberOfSigns)].map(() => '0').join('');
  //building 1000 from "1" and "000"
  const mult = Number(`1${zeroes}`);
  switch (mode) {
    case 'lower':
      return Math.floor(numberToRound * mult) / mult;
    case 'upper':
      return Math.ceil(numberToRound * mult) / mult;
    default:
      return Math.round(numberToRound * mult) / mult;
  }
};

type Grow<T, A extends Array<T>> = ((x: T, ...xs: A) => void) extends (
  ...a: infer X
) => void
  ? X
  : never;
type GrowToSize<T, A extends Array<T>, N extends number> = {
  0: A;
  1: GrowToSize<T, Grow<T, A>, N>;
}[A['length'] extends N ? 0 : 1];

export type ArrayOfSize<T, N extends number> = GrowToSize<T, [], N>;

export type NotEmptyArray<T> = [T, ...T[]];

export const getRandomElement = <T>(input: T[]): T => {
  return input[Math.trunc(Math.random() * input.length)];
};

export const encodeArray = (input: string[]): string => {
  return input.join('^');
};

export const decodeArray = (input: string): string[] => {
  return input.split('^');
};

export const cutNftName = (name: string): string => name.split(' (')[0];
